import { supabase } from '../supabaseClient';
import type { Clause } from '@shared/types';

export const clauseService = {
  async getClauses(filters?: { type?: string; approved?: boolean; search?: string }) {
    let query = supabase
      .from('clauses')
      .select('*')
      .order('created_at', { ascending: false });

    if (filters?.type) {
      query = query.eq('type', filters.type);
    }

    if (filters?.approved !== undefined) {
      query = query.eq('approved', filters.approved);
    }

    if (filters?.search) {
      query = query.or(`title.ilike.%${filters.search}%,body_html.ilike.%${filters.search}%`);
    }

    const { data, error } = await query;
    
    if (error) throw error;
    return data as Clause[];
  },

  async getClause(id: string) {
    const { data, error } = await supabase
      .from('clauses')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data as Clause;
  },

  async createClause(clause: Partial<Clause>) {
    const { data, error } = await supabase
      .from('clauses')
      .insert([clause])
      .select()
      .single();
    
    if (error) throw error;
    return data as Clause;
  },

  async updateClause(id: string, updates: Partial<Clause>) {
    const { data, error } = await supabase
      .from('clauses')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data as Clause;
  },

  async deleteClause(id: string) {
    const { error } = await supabase
      .from('clauses')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  },

  async searchByTags(tags: string[]) {
    const { data, error } = await supabase
      .from('clauses')
      .select('*')
      .contains('tags', tags);
    
    if (error) throw error;
    return data as Clause[];
  },
};

